"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var KeytipLayer_base_1 = require("./KeytipLayer.base");
var KeytipLayer_styles_1 = require("./KeytipLayer.styles");
exports.KeytipLayer = Utilities_1.styled(KeytipLayer_base_1.KeytipLayerBase, KeytipLayer_styles_1.getStyles, undefined, {
    scope: 'KeytipLayer'
});
//# sourceMappingURL=KeytipLayer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/KeytipLayer/KeytipLayer.js
// module id = 1096
// module chunks = 0